import { logger } from '../../classes/logger';

const isNewNotificationSupported = () => {

  if (!window.Notification || !Notification.requestPermission) return false;

  if (Notification.permission === 'granted') {

    // eslint-disable-next-line max-len
    logger.error('You must only call this *before* calling Notification.requestPermission(), otherwise this feature detect would bug the user with an actual notification!');

    return true;

  }

  try {

    // eslint-disable-next-line no-new
    new Notification('');

  } catch (e) {

    if (e.name === 'TypeError') return false;

  }

  return true;

};

export const notificationConstructorSupported = isNewNotificationSupported();
